<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索：
                        <el-input placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option
                                        v-for="item in keywordList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <!--
                    <el-button type="warning" @click="showFV = !showFV">
                        <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true"></i>
                    </el-button>
                    -->
                </div>
            </div>
            <div v-show="showFV" >
                <div  class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>
                        设备型号：
                        <el-select v-model="searchVal.devModelId" placeholder="设备型号" size="mini" clearable filterable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in devModels"
                                    :key="item.id"
                                    :label="item.model"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        仓储状态：
                        <el-select v-model="searchVal.devStrStatId" placeholder="仓储状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevStorageStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        激活状态：
                        <el-select v-model="searchVal.devActStatId" placeholder="激活状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevActiveStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        绑定状态：
                        <el-select v-model="searchVal.devBindStat" placeholder="绑定状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevBindStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div  class="yx-flex-h-start" style="margin-top: 15px;">

                    <div>
                        分配状态：
                        <el-select v-model="searchVal.devFpStat" placeholder="分配状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevDbStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>


                    <div>
                        入库日期：
                        <el-date-picker
                                v-model="searchVal.purDateScope"
                                value-format="yyyy-MM-dd"
                                type="daterange"
                                size="mini"
                                style="width:250px"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>

                </div>


            </div>
            <div class="yx-flex-h-start" style="margin-top: 15px;">
                <el-button type="danger" icon="el-icon-magic-stick" @click="viewAdd">生产支付码</el-button>
                <!--
                <el-button type="danger" icon="el-icon-truck" @click="showAddEmpView">调拨</el-button>
                <el-button type="danger" icon="el-icon-cpu" @click="showAddEmpView">维修</el-button>
                -->
            </div>
        </div>

        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :cell-style="columnbackgroundStyle"
                    :data="devices"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <!--
                <el-table-column type="selection" align="center" />
                -->
                <el-table-column prop="qrSn" label="终端SN" width="120" />
                <el-table-column prop="qrCode" label="支付QR" show-overflow-tooltip />
                <!--
                <el-table-column prop="dyCode" label="抖音QR" show-overflow-tooltip  />
                -->
                <el-table-column prop="mchName" label="绑定商户" width="220"  show-overflow-tooltip />
                <el-table-column prop="agentName" label="归属" width="120"  show-overflow-tooltip />
                <el-table-column label="状态" width="100" align="center" >
                    <template slot-scope="scope">
                        <el-tag effect="dark" type="success" v-if="scope.row.status===0" >初始</el-tag>
                        <el-tag effect="dark" type="info" v-else-if="scope.row.status===1">激活</el-tag>
                        <el-tag effect="dark" type="info" v-else-if="scope.row.status===2">占用</el-tag>
                        <el-tag effect="dark" type="info" v-else-if="scope.row.status===-1">停用</el-tag>
                        <el-tag effect="dark" type="info" v-else>未知</el-tag>
                    </template>
                </el-table-column>
                <!--
                <el-table-column prop="mchId" label="商户ID" width="100" />
                <el-table-column prop="agentId" label="代理商ID" width="100" />
                <el-table-column prop="storeNo" label="门店号" width="100" />
                -->
                <el-table-column prop="createTime" width="150" label="创建时间" sortable align="center" />
                <el-table-column fixed="right" label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" plain size="mini" style="padding: 5px" @click="viewDetail(scope.row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="width: 1px" />
            <!--
            <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
            -->
            <div class="yx-flex-v">
                <!--
                <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
                -->
                <el-tag type="info" style="margin-left: 0px;">
                    <i class="header-icon el-icon-info"></i>
                    状态统计：&nbsp;&nbsp;
                    {{totalTxt}}
                </el-tag>
            </div>
            <el-pagination
                    background
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="slot, sizes, prev, pager, next, jumper, total"
                    :pager-count="5"
                    :total="total">
                <!--
                <span>共计{{total}}台&nbsp;&nbsp;</span>
                -->
            </el-pagination>
        </div>

        <el-dialog
                :title="titleDlg"
                :visible.sync="showDlg"
                :lock-scroll="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                width="60%"
                class="dlg-normal">
            <div style="height: 380px; margin-top: 5px; overflow-y: auto;">
                <el-form :model="insPayQrForm" :rules="rules" ref="insPayQrForm">
                    <div class="form-s">
                        <el-row :gutter="30">
                            <div class="yx-flex-h-start">
                                <el-form-item label="生产数量" prop="cNum">
                                    <el-input-number v-model="insPayQrForm.cNum" :min="1" :max="1000" label="生产数量"></el-input-number>
                                </el-form-item>
                                <el-radio-group v-model="insPayQrForm.cType" style="margin-left: 20px;">
                                    <el-radio-button :label=Number(1)>生产调拨</el-radio-button>
                                    <el-radio-button :label=Number(0)>仅入库</el-radio-button>
                                </el-radio-group>
                            </div>

                        </el-row>
                        <el-row :gutter="30" v-if="insPayQrForm.cType===1">
                            <div class="yx-flex-h-start">
                                <el-form-item label="码牌单价" prop="price">
                                    <el-input-number v-model="insPayQrForm.price" :min="0" :max="1000" label="单价"></el-input-number>
                                </el-form-item>
                                <el-form-item  style="margin-left: 20px;">
                                    <span>订单金额： {{amount}} 元</span>
                                </el-form-item>
                            </div>
                        </el-row>
                        <el-row :gutter="30" v-if="insPayQrForm.cType===1">
                            <el-form-item label="接收单位" prop="inAgentId">
                                <el-select v-model="insPayQrForm.inAgentId" placeholder="接收单位" size="small" filterable @change="getAgentName2"
                                           style="width: 100%;">
                                    <el-option
                                            v-for="item in arch_allAgentIdNameWithOutThis"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="调拨单号" prop="allotBatNo">
                                <el-input size="small" v-model="insPayQrForm.allotBatNo" :disabled="true" />
                            </el-form-item>
                        </el-row>
                    </div>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="yx-flex-h-between">
                    <div class="yx-flex-v">
                    </div>
                    <div>
                        <el-button size="small" @click="showDlg = false">取 消</el-button>
                        <el-button size="small" type="primary" @click="dlgCommit">确 定</el-button>
                    </div>
                </div>

            </span>
        </el-dialog>



        <el-drawer
                class="drw"
                :with-header=false
                :visible.sync="drawer"
                :show-close=false
                size = "50%"
                direction="rtl">
            <QrDetailDiv :key="detailData.id" :in-detail-data="detailData" v-bind:outDrawerClose.sync="drawerRe"></QrDetailDiv>
        </el-drawer>
    </div>

</template>

<script>

    import {
        URL_DEV_MODELS,
        URL_DATA_PURBATNO, URL_DATA_ALLOTORDERNO, URL_AGENT_FROMS
    } from "../../utils/cons";
    import AreaSelect from "../../components/pub/AreaSelect";
    import QrDetailDiv from "../../components/qr/QrDetailDiv";
    import {deepClone, findIdxByKeyValue} from "../../utils/datatool";

    export default {
        name: "QrPayMng",
        components: {QrDetailDiv, AreaSelect},
        data() {
            return {
                title: '',
                drawer: false,
                drawerRe: false,
                showFV: false,
                dialogVisible: false,
                loading: false,
                total: 0,
                totalTxt:'',
                page: 1,
                size: 10,
                titleDlg: '生产支付码',
                showDlg: false,
                devices: [],
                devModels: [],
                detailData:{},
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    purDateScope: null,
                    devModelId: null,
                    devStrStatId: null,
                    devActStatId: null,
                    devBindStat: null,
                    devFpStat: null
                },
                keywordList: [
                    {id:"inAgentName",name:"所属服务商"},
                    {id:"terSn",name:"终端SN"}
                ],
                devCnt: 0,
                devObj: {total:0,tsnLst:null},
                devMod: '',
                devDetail: {
                    terSn: null
                },
                initDevInfoForm: {
                    modelId: null,
                    termSnTxt: null,
                    devDetails: [],
                    abc:'主仓库',
                    purBatNo:null,
                    purDateTime:null,
                    devStrStat:1,
                    devActStat:1,
                    inAgentId:1,
                    inAgentName:null,
                    inDateTime:null
                },
                arch_allAgentIdNameWithOutThis: null,
                insPayQrForm: {
                    cNum: null,
                    price: 2,
                    cType: 1,
                    allotBatNo: null,
                    inAgentCode: null,
                    inAgentId : null,
                    inAgentName: null,
                    expressComp: null,
                    expressNo: null,
                    termSnTxt: null,
                    devAllotDetails: []
                },
                insDevInfoForm: {
                    channelCode: null,
                    modelId: null,
                    termSnTxt: null,
                    devDetails: [],
                    abc:'主仓库',
                    purBatNo:null,
                    purDateTime:null,
                    devStrStat:1, //仓储状态 默认1.在库
                    devActStat:1, //激活状态 默认1.空置
                    inAgentId:1,  //所属服务商 默认1.公司
                    inAgentName:null,
                    inDateTime:null
                },
                insDevInfoList: [],
                insDevInfo: {
                    channelCode: null,
                    modelId:null,
                    terSn:null,
                    purBatNo:null,
                    devStrStat:null,
                    devActStat:null
                },
                rules: {
                    inAgentId: [{required: true, message: '请选择接收单位', trigger: 'blur'}],
                    allotBatNo: [{required: true, message: 'allotBatNo', trigger: 'blur'}],
                    cNum: [{required: true, message: 'cNum', trigger: 'blur'}],
                    price: [{required: true, message: 'price', trigger: 'blur'}],
                    /*
                    termSnTxt: [{required: true, message: '请输入设备序列号', trigger: 'blur'}],
                    expressComp: [{required: true, message: '请输入物流公司', trigger: 'blur'}],
                    expressNo: [{required: true, message: '请输入物流单号', trigger: 'blur'}],
                    */
                }
            }
        },
        watch:{
            insDevInfoForm: {
                handler:function(val) {

                    for(let i=0;i<this.devModels.length;i++) {
                        if(this.insDevInfoForm.modelId==this.devModels[i].id) {
                            this.devMod = this.devModels[i].model;
                            break;
                        }
                    }

                    if(this.insDevInfoForm.termSnTxt && this.insDevInfoForm.termSnTxt.length>0) {
                        this.devObj = this._StringUtils.batTermSn(this.insDevInfoForm.termSnTxt);
                        if(this.devObj) {
                            this.devCnt = this.devObj.total;
                        }
                        else {
                            this.devCnt = 'x--x--x 格式错 x--x--x';
                        }
                    }
                },
                deep:true
            }
        },
        computed: {
            amount() {
                return this.insPayQrForm.cNum*this.insPayQrForm.price;
            }
        },
        mounted() {
            this.initDevices();
            this.getRequest(URL_DEV_MODELS).then(resp => { if (resp) this.devModels = resp.data });

            // 全部服务商ID列表
            this.getRequest(URL_AGENT_FROMS + "?lmt=1").then(resp => {
                if (resp) {
                    // 初始 - 代理商编辑时，选择推荐代理商，不包含当前编辑的服务商ID。
                    this.arch_allAgentIdNameWithOutThis = deepClone(resp.data);
                    let idx = findIdxByKeyValue(this.arch_allAgentIdNameWithOutThis, 'code', this.insPayQrForm.inAgentCode);
                    if(idx) this.arch_allAgentIdNameWithOutThis.splice(idx,1);
                }
            });
        },
        methods: {
            // 改变Table某一列的背景颜色
            // columnIndex为列下标
            columnbackgroundStyle({ row, column, rowIndex, columnIndex }) {
                if (column.label == '操作') {
                    //让下标为1的列数背景颜色显示为红色（颜色自定义根据大家需求来）
                    return 'background:#fafafa;'
                }
            },
            viewDetail(data) {
                Object.assign(this.detailData, data);
                this.drawer = true;
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initDevices();
            },
            getAgentName2() {
                this.arch_allAgentIdNameWithOutThis.forEach(item => {
                    if (item.id === this.insPayQrForm.inAgentId) {
                        this.insPayQrForm.inAgentCode = item.code
                        this.insPayQrForm.inAgentName = item.name
                    }
                })
            },
            exportData() {
                let urlParam = '/dev/devInfoAll/export?page=1';

                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    urlParam += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }
                if (this.searchVal.devModelId) {
                    urlParam += '&modelId=' + this.searchVal.devModelId;
                }
                if (this.searchVal.devStrStatId) {
                    urlParam += '&devStrStat=' + this.searchVal.devStrStatId;
                }
                if (this.searchVal.devActStatId) {
                    urlParam += '&devActStat=' + this.searchVal.devActStatId;
                }
                if (this.searchVal.devBindStat) {
                    urlParam += '&devBindStat=' + this.searchVal.devBindStat;
                }
                if(this.searchVal.devFpStat) {
                    urlParam += '&inAgentId='  + this.searchVal.devFpStat;
                }
                if (this.searchVal.purDateScope) {
                    urlParam += '&purDateScope=' + this.searchVal.purDateScope;
                }

                window.open(urlParam, '_parent');
            },
            initDevices() {
                this.loading = true;
                let urlParam = '?page=' + this.page + '&size=' + this.size;

                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    urlParam += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }
                if (this.searchVal.devModelId) {
                    urlParam += '&modelId=' + this.searchVal.devModelId;
                }
                if (this.searchVal.devStrStatId) {
                    urlParam += '&devStrStat=' + this.searchVal.devStrStatId;
                }
                if (this.searchVal.devActStatId) {
                    urlParam += '&devActStat=' + this.searchVal.devActStatId;
                }
                if (this.searchVal.devBindStat) {
                    urlParam += '&devBindStat=' + this.searchVal.devBindStat;
                }
                if(this.searchVal.devFpStat) {
                    urlParam += '&inAgentId='  + this.searchVal.devFpStat;
                }
                if (this.searchVal.purDateScope) {
                    urlParam += '&purDateScope=' + this.searchVal.purDateScope;
                }

                this.getRequest("/dev/payQrInfo" + urlParam).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.devices = resp.data;
                        this.total = resp.total;
                    }
                });

                this.totalTxt = '';
                this.getRequest("/dev/devInfoStatActTotal" + urlParam).then(resp => {
                    this.loading = false;
                    if (resp) {
                        let ar = resp.data;
                        this.totalTxt = ar[0];
                    }
                });

            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initDevices();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initDevices();
            },
            getAllotOrderNo() {
                this.getRequest(URL_DATA_ALLOTORDERNO).then(resp => { if (resp) this.insPayQrForm.allotBatNo = resp.obj.no });
            },
            viewAdd() {
                this.getAllotOrderNo();
                this.showDlg = true;
            },
            getPurBatNo() {
                this.getRequest(URL_DATA_PURBATNO).then(resp => { if (resp) this.insDevInfoForm.purBatNo = resp.obj.no });
            },
            dlgCommit() {
                this.insertDevInfo();
            },
            insertDevInfo() {

                this.$refs['insPayQrForm'].validate(valid => {
                    if (valid) {
                        this.$confirm('生产数量：' + this.insPayQrForm.cNum + '台', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {

                            this.postRequest("/dev/createPayQr", this.insPayQrForm).then(resp => {
                                if (resp) {
                                    this.initDevices();
                                    this.showDlg = false;
                                }
                            })

                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消'
                            });
                        });
                    }
                });


            }
        }

    }
</script>

<style scoped>

</style>
